import type { PublishProfile } from "./types";

function profileSlug(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-+/g, "-");
}

export function uniquePublishProfileId(name: string, profiles: readonly PublishProfile[]): string {
  const base = profileSlug(name) || "profile";
  const existing = new Set(profiles.map((profile) => profile.id));
  if (!existing.has(base)) return base;
  let suffix = 2;
  while (existing.has(`${base}-${suffix}`)) suffix += 1;
  return `${base}-${suffix}`;
}
